import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
// import {SmsInboundService} from '@services/sms-inbound.service';
import { BrandName, formateDateTime, validateFormGroup } from '@utils/utils';
import { AtlasGridTranslateRendererComponent } from '@ui/components/atlas-grid/renderer/translate-renderer.component';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, Validators, AbstractControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { AtlasGridHtmlRendererComponent } from '@ui/components/atlas-grid/renderer/html-renderer.component';
import { UserService } from '@services/user.service';
import { Subscription } from 'rxjs';
import { SenderService } from '@services/sender.service';
import { ButtonGroupRendererComponent } from '@ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { SmsSenderAgcom } from '@models/sms/sender';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';
import { DomainService } from '@services/domain.service';
import * as _ from 'lodash';
import { ToastContainerDirective } from 'ngx-toastr';
import { environment } from '@env';
import { AtlasGridOptions } from '@ui/components/atlas-grid/altas-grid-options.model';
import { GridReadyEvent } from 'ag-grid-community';
import { LoaderService } from '@services/loader.service';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from '@services/menu.service';
import { SMS_SENDERS } from '@models/menu-entries';
import { senderValidator, requiredFileArray } from '@utils/validators';
import { getNation3FlagUrl, getNationByIso3166Code } from '@utils/utils';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'wsb-smsin',
  templateUrl: './senders.component.html',
  styleUrls: ['./senders.component.scss'],
  animations: [
    trigger('gridIsLoaded', [
      state('hide', style({ opacity: 0 })),
      state('show', style({ opacity: 1 })),
      transition('hide => show', animate('150ms', style({ opacity: 1 }))),
      transition('show => hide', animate('150ms', style({ opacity: 0 })))
    ])
  ],
  standalone: false
})
export class SmsSendersComponent implements OnInit, OnDestroy, AfterViewInit {
  hasValidatedSendersList = false;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @ViewChild('alphaGrid') alphaGrid: AtlasGridComponent;
  @ViewChild('modalAddEditAlpha') modalAddEditAlpha;
  @ViewChild('modalAddEditAlphaDisabled') modalAddEditAlphaDisabled;
  @ViewChild('modalDeleteAlpha') modalDeleteAlpha;
  modalAddEditAlphaModal: NgbModalRef;
  modalAddEditAlphaDisabledModal: NgbModalRef;
  modalDeleteAlphaModal: NgbModalRef;

  @ViewChild('numericGrid') numericGrid: AtlasGridComponent;
  @ViewChild('modalAddNumeric') modalAddNumeric;
  @ViewChild('modalDeleteNumeric') modalDeleteNumeric;
  modalAddNumericModal: NgbModalRef;
  modalAddNumericModalConfirm: NgbModalRef;
  modalDeleteNumericModal: NgbModalRef;

  tableSendersNumericColumnDefs = null;
  tableSendersNumericGridOptions = null;
  tableSendersNumericLoading: boolean;

  tableSendersAlphaColumnDefs = null;
  tableSendersAlphaGridOptions = null;
  tableSendersAlphaLoading: boolean;

  senderToEdit: SmsSenderAgcom;
  senderToEditFull: SmsSenderAgcom;
  senderToDelete: SmsSenderAgcom;
  senderToConfirm: SmsSenderAgcom;

  addAlphaSenderForm: UntypedFormGroup = null;
  addNumericSenderForm: UntypedFormGroup = null;
  confirmNumericSenderForm: UntypedFormGroup = null;

  canManageAlphaSenders = true;
  itsIta = false;
  destinationTerritories = [];
  IsDestinationIsUK = false;
  IsDestinationIsIE = false;
  IsDestinationIsFR = false;
  IsDestinationIsES = false;
  private isCustomer;
  private isSubAccount;
  private userSubscription: Subscription;
  paginationPageSize = 10;
  components = {
    buttonGroupRenderer: ButtonGroupRendererComponent,
    translateRenderer: AtlasGridTranslateRendererComponent,
    htmlRenderer: AtlasGridHtmlRendererComponent
  };

  statusMap = {
    UNCONFIRMED: 'agcom_tpoa_status_0',
    ERROR_DURING_UPLOAD: 'agcom_tpoa_status_0',
    CONFIRMEDBYAGCOM: 'agcom_tpoa_status_2',
    PRECONFIRMEDBYONEETERE: 'agcom_tpoa_status_2',
    CONFIRMEDBYONEETERE: 'agcom_tpoa_status_2',
    BLOCKEDBYAGCOM: 'agcom_tpoa_status_3',
    BLOCKEDBYONEETERE: 'agcom_tpoa_status_3'
  };
  gridAnimationStateAlpha = 'hide';
  gridAnimationStateNumeric = 'hide';
  alertNumericKeyTranslate = 'sender_numeric_alert';
  alertNumericMessage = '';
  canRegisterSender = false;
  customerVatCode: string = '';
  constructor(
    private modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private atlasToast: AtlasToastService,
    private domainService: DomainService,
    private loaderService: LoaderService,
    private userService: UserService,
    private senderService: SenderService,
    private atlasToastService: AtlasToastService,
    private translateService: TranslateService,
    private menuService: MenuService,
    private sessionStorage: SessionStorageService
  ) {}

  ngOnInit() {
    this.getDestinationTerritories();

    this.translateService.get(this.alertNumericKeyTranslate).subscribe(label => {
      this.alertNumericMessage = label;
    });
    const that = this;

    this.domainService.getDomainState().subscribe(domain => {
      this.canManageAlphaSenders = domain.tpoaSenderManagement === 'NONE';

      const tableSendersAlphaColumnDefs: any = [
        {
          headerNameTranslate: 'sender_sender',
          field: 'sender',
          sortable: false
        }
      ];
      if (this.canManageAlphaSenders) {
        tableSendersAlphaColumnDefs.push(
          ...[
            {
              headerNameTranslate: 'sender_destination_nation',
              field: 'type',
              cellRenderer: 'htmlRenderer',
              sortable: false,
              cellRendererParams: {
                content: params => {
                  if (params && params.data) {
                    const nation = getNationByIso3166Code(params.data.destinationTerritory);
                    const nationCodeFlag = getNation3FlagUrl(nation[0]);
                    return '<img class="flag" src="' + nationCodeFlag + '" /> ';
                  }
                }
              }
            },
            {
              headerNameTranslate: 'common_status',
              field: 'status',
              sortable: false,
              // resizable: false,
              // cellRenderer: 'translateRenderer',
              // cellRendererParams: {
              //   content: params => (params && params.data ? this.statusMap[params.data.status] : '')
              // },
              cellRenderer: 'htmlRenderer',
              cellRendererParams: {
                content: params => {
                  if (params && params.data) {
                    let badgeLabel;
                    this.translateService.get(params.data.statusLabel).subscribe(label => {
                      badgeLabel = label;
                    });
                    switch (params.data.status) {
                      case 'UNCONFIRMED':
                      case 'SUBMITTED':
                        return '<span class="badge badge-pending">' + badgeLabel + '</span>';
                        break;
                      case 'CONFIRMEDBYAGCOM':
                      case 'CONFIRMEDBYONEETERE':
                      case 'APPROVED':
                        return '<span class="badge badge-ok">' + badgeLabel + '</span>';
                        break;
                      case 'PRECONFIRMEDBYONEETERE':
                        return '<span class="badge badge-preok">' + badgeLabel + '</span>';
                        break;
                      case 'ERROR_DURING_UPLOAD':
                      case 'BLOCKEDBYAGCOM':
                      case 'BLOCKEDBYONEETERE':
                        return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                        break;
                      default:
                        return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                        break;
                    }
                  }
                  return '';
                }
              }
            },
            {
              headerNameTranslate: 'common_data_approvation',
              field: 'lastUpdate',
              cellRenderer: 'htmlRenderer',
              sortable: false,
              // resizable: false,
              cellRendererParams: {
                content: params => (params && params.data && params.data.lastUpdate ? formateDateTime(params.data.lastUpdate) : '')
              }
            }
          ]
        );
      }
      // if (this.itsIta) {
      //   tableSendersAlphaColumnDefs.push(
      //     ...[
      //       {
      //         headerNameTranslate: 'common_actions',
      //         suppressCellFocus: true,
      //         cellRenderer: 'buttonGroupRenderer',
      //         cellRendererParams: {
      //           items: [
      //             {
      //               label: 'common_edit',
      //               onClick: e => {
      //                 this.openmodalAddEditAlpha(e);
      //               }
      //             },
      //             {
      //               label: 'common_delete',
      //               onClick: e => {
      //                 this.openModalDeleteAlpha(e);
      //               }
      //             }
      //           ]
      //         },
      //         cellClass: ['button-group', 'text-end'],
      //         maxWidth: 82,
      //         field: '__actions'
      //       }
      //     ]
      //   );
      // } else {
      //   tableSendersAlphaColumnDefs.push(
      //     ...[
      //       {
      //         headerNameTranslate: 'common_actions',
      //         suppressCellFocus: true,
      //         cellRenderer: 'buttonGroupRenderer',
      //         cellRendererParams: {
      //           items: [
      //             {
      //               label: 'common_edit',
      //               onClick: e => {
      //                 this.openmodalAddEditAlpha(e);
      //               }
      //             }
      //           ]
      //         },
      //         cellClass: ['button-group', 'text-end'],
      //         maxWidth: 82,
      //         field: '__actions'
      //       }
      //     ]
      //   );
      // }
      tableSendersAlphaColumnDefs.push(
        ...[
          {
            headerNameTranslate: 'common_actions',
            suppressCellFocus: true,
            cellRenderer: 'buttonGroupRenderer',
            cellRendererParams: {
              items: [
                {
                  label: 'common_view',
                  onClick: e => {
                    this.openmodalAddEditAlpha(e);
                  }
                }
              ]
            },
            cellClass: ['button-group', 'text-end'],
            maxWidth: 82,
            field: '__actions'
          }
        ]
      );
      this.tableSendersAlphaColumnDefs = tableSendersAlphaColumnDefs;
    });

    this.tableSendersNumericColumnDefs = [
      {
        headerNameTranslate: 'sender_sender',
        field: 'sender',
        sortable: false
      },
      {
        headerNameTranslate: 'common_status',
        field: 'status',
        sortable: false,
        // resizable: false,
        // cellRenderer: 'translateRenderer',
        // cellRendererParams: {
        //   content: params => (params && params.data ? this.statusMap[params.data.status] : '')
        // }
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              let badgeLabel;
              this.translateService.get(this.statusMap[params.data.status]).subscribe(label => {
                badgeLabel = label;
              });
              switch (params.data.status) {
                case 'UNCONFIRMED':
                  return '<span class="badge badge-pending">' + badgeLabel + '</span>';
                  break;
                case 'CONFIRMEDBYAGCOM':
                case 'CONFIRMEDBYONEETERE':
                  return '<span class="badge badge-ok">' + badgeLabel + '</span>';
                  break;
                case 'PRECONFIRMEDBYONEETERE':
                  return '<span class="badge badge-preok">' + badgeLabel + '</span>';
                  break;
                case 'ERROR_DURING_UPLOAD':
                case 'BLOCKEDBYAGCOM':
                case 'BLOCKEDBYONEETERE':
                  return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                  break;
              }
            }
            return '';
          }
        }
      },
      {
        headerNameTranslate: 'common_data_approvation',
        field: 'lastNotifyAliasDate',
        cellRenderer: 'htmlRenderer',
        sortable: false,
        cellRendererParams: {
          content: params =>
            params && params.data && params.data.lastNotifyAliasDate ? formateDateTime(params.data.lastNotifyAliasDate) : ''
        }
      }
      // {
      //   headerNameTranslate: 'common_actions',
      //   suppressCellFocus: true,
      //   cellRenderer: 'buttonGroupRenderer',
      //   cellRendererParams: {
      //     items: [
      //       {
      //         label: 'common_delete',
      //         onClick: e => {
      //           this.openModalDeleteNumeric(e);
      //         }
      //       }
      //     ]
      //   },
      //   cellClass: ['button-group', 'text-end'],
      //   maxWidth: 82,
      //   field: '__actions'
      // }
    ];

    this.tableSendersAlphaGridOptions = AtlasGridOptions.deserialize({
      onGridReady: (event: GridReadyEvent) => {
        this.gridAnimationStateAlpha = 'show';
      },
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      loadFunction: this.reloadListAgcom.bind(that),
      autoHeight: true
    });

    this.tableSendersNumericGridOptions = AtlasGridOptions.deserialize({
      onGridReady: (event: GridReadyEvent) => {
        this.gridAnimationStateNumeric = 'show';
      },
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      loadFunction: this.reloadListNormal.bind(that),
      autoHeight: true
    });

    this.addAlphaSenderForm = this.formBuilder.group({
      sender: ['', [Validators.required, senderValidator(11)]],
      contactName: ['', [Validators.required]],
      contactSurname: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      contactAddress: ['', [Validators.required]],
      contactPostalCode: ['', [Validators.required]],
      contactCity: ['', [Validators.required]],
      vatNumber: ['', [Validators.required]],
      fiscalCode: ['', [Validators.required]],
      // contactType: ['', [Validators.required]],
      contactInfo: ['', [Validators.required, Validators.email]],
      authorize: ['', [Validators.required]],
      // file: [''],
      filesUpload: this.formBuilder.array([]),
      destinationTerritory: ['', [Validators.required]],
      sidrId: ['', [Validators.required]],
      nifTitular: [''],
      nifConfirmation: ['confirm']
    });

    this.addNumericSenderForm = this.formBuilder.group({
      number: ['', [Validators.required, Validators.pattern(/^(\+)?[0-9]{5,15}$/)]]
    });
    this.confirmNumericSenderForm = this.formBuilder.group({
      pin: ['', [Validators.required]]
    });

    // on change destinationTerritory
    this.addAlphaSenderForm.get('destinationTerritory').valueChanges.subscribe(value => {
      const senderControl = this.addAlphaSenderForm.get('sender');
      if (senderControl) {
        senderControl.setValidators([Validators.required, senderValidator(11)]);
      }

      this.addAlphaSenderForm.get('sidrId').clearValidators();
      this.addAlphaSenderForm.get('sidrId').updateValueAndValidity();
      this.addAlphaSenderForm.get('filesUpload').clearValidators();
      this.addAlphaSenderForm.get('filesUpload').updateValueAndValidity();
      this.setOptionalsValidatorsAlphaSenderForm(true);

      this.IsDestinationIsUK = false;
      this.IsDestinationIsIE = false;
      this.IsDestinationIsFR = false;
      this.IsDestinationIsES = false;

      switch (value) {
        case 'IE':
          this.addAlphaSenderForm.get('sidrId').setValidators([Validators.required]);
          this.addAlphaSenderForm.get('sidrId').updateValueAndValidity();
          this.buildFileUpload(0);
          this.IsDestinationIsIE = true;
          break;
        case 'GB':
          this.IsDestinationIsUK = true;
          this.buildFileUpload(1);
          break;
        case 'FR':
          this.buildFileUpload(0);

          this.IsDestinationIsFR = true;
          this.setOptionalsValidatorsAlphaSenderForm(false);

          break;
        case 'ES':
          this.IsDestinationIsES = true;
          this.buildFileUpload(0);
          if (senderControl) {
            senderControl.setValidators([Validators.required, Validators.pattern(/^[a-zA-ZñÑçÇ0-9 @&\-_\.\+]{3,11}$/)]);
          }
          break;
        default:
          this.buildFileUpload(2);
          if (this.isFileUploadRequired()) {
            const filesUploadControl = this.addAlphaSenderForm.get('filesUpload');
            filesUploadControl.setValidators(requiredFileArray(2));
            filesUploadControl.updateValueAndValidity();
          }
          break;
      }
      if (senderControl) {
        senderControl.updateValueAndValidity();
      }
    });
  }

  private setOptionalsValidatorsAlphaSenderForm(required: boolean) {
    if (required) {
      this.addAlphaSenderForm.get('contactAddress').setValidators([Validators.required]);
      this.addAlphaSenderForm.get('contactPostalCode').setValidators([Validators.required]);
      this.addAlphaSenderForm.get('contactCity').setValidators([Validators.required]);
      this.addAlphaSenderForm.get('vatNumber').setValidators([Validators.required]);
      this.addAlphaSenderForm.get('fiscalCode').setValidators([Validators.required]);
      this.addAlphaSenderForm.get('contactInfo').setValidators([Validators.required, Validators.email]);
    } else {
      this.addAlphaSenderForm.get('contactAddress').clearValidators();
      this.addAlphaSenderForm.get('contactPostalCode').clearValidators();
      this.addAlphaSenderForm.get('contactCity').clearValidators();
      this.addAlphaSenderForm.get('vatNumber').clearValidators();
      this.addAlphaSenderForm.get('fiscalCode').clearValidators();
      this.addAlphaSenderForm.get('contactInfo').clearValidators();
    }
    this.addAlphaSenderForm.get('contactAddress').updateValueAndValidity();
    this.addAlphaSenderForm.get('contactPostalCode').updateValueAndValidity();
    this.addAlphaSenderForm.get('contactCity').updateValueAndValidity();
    this.addAlphaSenderForm.get('vatNumber').updateValueAndValidity();
    this.addAlphaSenderForm.get('fiscalCode').updateValueAndValidity();
    this.addAlphaSenderForm.get('contactInfo').updateValueAndValidity();
  }

  ngAfterViewInit(): void {
    this.atlasToastService.info('senders_australia_alert_title', 'senders_australia_alert', -1, this.toastContainer);
    this.userSubscription = this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.menuService.getMenuEntriesState().subscribe((entries: any) => {
        if (entries[SMS_SENDERS]) {
          this.itsIta = true;
        }
        this.hasValidatedSendersList = loggedUser.hasValidatedSendersList() || !this.itsIta;
        if (!this.hasValidatedSendersList) {
          this.atlasToastService.info('sms_senders_error_alpha_register_message', '', -1, this.toastContainer);
        }
        if (loggedUser) {
          this.customerVatCode = loggedUser.billing?.vatCode || '';
        }
      });

      this.isCustomer = loggedUser.account.isCustomer;
      this.isSubAccount = !_.isUndefined(loggedUser.account.subaccount);
      this.canRegisterSender =
        environment.brandName !== BrandName.VODAFONE &&
        environment.brandName !== BrandName.ARUBA &&
        (loggedUser.account?.canRegisterSender || false);
    });
  }

  isFileUploadRequired() {
    switch (this.sessionStorage.retrieve('wsb-brand-name')) {
      case BrandName.SMSENVOI:
      case BrandName.MOBYTFR:
      case BrandName.MEDIABURST:
      case BrandName.ESENDEXAU:
        return true;
      default:
        return false;
    }
  }

  reloadListAgcom(startRow?, endRow?, sort?) {
    this.loaderService.show();
    return this.senderService
      .getAgcomSisSendersAlphaNumeric(true, 1 + startRow / (endRow - startRow), endRow - startRow)
      .pipe(finalize(() => this.loaderService.hide()));
  }

  reloadListNormal(startRow?, endRow?, sort?) {
    this.loaderService.show();
    return this.senderService
      .getAgcomSisSendersNumeric(true, 1 + startRow / (endRow - startRow), endRow - startRow)
      .pipe(finalize(() => this.loaderService.hide()));
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  openModalDeleteAlpha(e): void {
    this.senderToDelete = e;
    this.modalDeleteAlphaModal = this.modalService.open(this.modalDeleteAlpha);
    this.modalDeleteAlphaModal.result.then(
      result => {},
      reason => {}
    );
  }

  modalDeleteAlphaForm(): void {
    const that = this;
    this.alphaGrid.showLoading();
    this.senderService.removeAgcomSender(this.senderToDelete).subscribe(x => {
      that.alphaGrid.refresh();
    });
    this.modalDeleteAlphaModal.close();
  }

  openModalDeleteNumeric(e): void {
    this.senderToDelete = e;
    this.modalDeleteNumericModal = this.modalService.open(this.modalDeleteNumeric);
    this.modalDeleteNumericModal.result.then(
      result => {},
      reason => {}
    );
  }

  modalDeleteNumericForm(): void {
    const that = this;
    this.numericGrid.showLoading();
    this.senderService.removeAgcomSender(this.senderToDelete).subscribe(x => {
      that.numericGrid.refresh();
    });
    this.modalDeleteNumericModal.close();
  }

  openmodalAddEditAlphaDisabled(e?): void {
    this.modalAddEditAlphaDisabledModal = this.modalService.open(this.modalAddEditAlphaDisabled);
    this.modalAddEditAlphaDisabledModal.result.then(
      result => {},
      reason => {}
    );
  }

  openmodalAddEditAlpha(e?): void {
    if (!this.isCustomer && !this.isSubAccount) {
      // this.openmodalAddEditAlphaDisabled();
      // return;
    }
    this.addAlphaSenderForm.reset();
    this.addAlphaSenderForm.patchValue({
      nifConfirmation: 'confirm',
      nifTitular: this.customerVatCode
    });
    this.senderToEditFull = null;
    if (e) {
      this.senderToEdit = e;
      this.senderService.getAgcomSender(e.idSender).subscribe(sender => {
        this.senderToEditFull = sender;
        this.addAlphaSenderForm.patchValue({
          sender: sender.sender,
          contactName: sender.agcomTpoaUserDTO.contactName,
          contactSurname: sender.agcomTpoaUserDTO.contactSurname,
          companyName: sender.agcomTpoaUserDTO.companyName,
          contactAddress: sender.agcomTpoaUserDTO.contactAddress,
          contactPostalCode: sender.agcomTpoaUserDTO.contactPostalCode,
          contactCity: sender.agcomTpoaUserDTO.contactCity,
          vatNumber: sender.agcomTpoaUserDTO.vatNumber,
          fiscalCode: sender.agcomTpoaUserDTO.fiscalCode,
          contactType: ['', [Validators.required]],
          contactInfo: sender.agcomTpoaUserDTO.contactInfo,
          destinationTerritory: sender.agcomTpoaUserDTO.destinationTerritory
        });
      });
    } else {
      this.senderToEdit = null;
    }

    this.modalAddEditAlphaModal = this.modalService.open(this.modalAddEditAlpha, { size: 'lg' });
    this.modalAddEditAlphaModal.result.then(
      result => {},
      reason => {
        if (!this.senderToEdit) {
          this.alphaGrid.refresh();
        }
      }
    );
  }

  modalAddEditAlphaForm(): void {
    if (!this.addAlphaSenderForm.valid) {
      validateFormGroup(this.addAlphaSenderForm);
      return;
    }

    const nifTitularValue = this.IsDestinationIsES ? this.addAlphaSenderForm.get('nifTitular').value : null;

    this.senderToConfirm = SmsSenderAgcom.deserialize({
      sender: this.addAlphaSenderForm.get('sender').value,
      destinationTerritory: this.addAlphaSenderForm.get('destinationTerritory').value,
      sidrId: this.addAlphaSenderForm.get('sidrId').value,
      nifTitular: nifTitularValue,
      companyInfo: {
        contactName: this.addAlphaSenderForm.get('contactName').value,
        contactSurname: this.addAlphaSenderForm.get('contactSurname').value,
        companyName: this.addAlphaSenderForm.get('companyName').value,
        contactAddress: this.addAlphaSenderForm.get('contactAddress').value,
        contactPostalCode: this.addAlphaSenderForm.get('contactPostalCode').value,
        contactCity: this.addAlphaSenderForm.get('contactCity').value,
        vatNumber: this.addAlphaSenderForm.get('vatNumber').value,
        fiscalCode: this.addAlphaSenderForm.get('fiscalCode').value,
        contactType: 'PEC',
        contactInfo: this.addAlphaSenderForm.get('contactInfo').value,
        destinationTerritory: this.addAlphaSenderForm.get('destinationTerritory').value
      }
    });
    this.alphaGrid.showLoading();
    let subscription;
    if (this.senderToEdit) {
      subscription = this.senderService.editAgcomSenderAlpha(this.senderToEdit.idSender, this.addAlphaSenderForm.get('contactInfo').value);
    } else {
      const filesUpload = this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray;
      const sisService = filesUpload.value.filter(x => x.file instanceof File).length > 0;
      subscription = this.senderService.addAgcomSenderAlpha(this.senderToConfirm, sisService);
    }

    subscription.subscribe(data => {
      if ((data.agcomStatus && data.agcomStatus === 'ERROR') || (data.senderRequestStatus && data.senderRequestStatus === 'ERROR')) {
        this.atlasToast.error('common_error', 'error_' + -data.errorCode);
      } else {
        const filesUploads = this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray;
        const files = filesUploads.value.filter(x => x.file instanceof File).map(x => x.file);
        if (files.length > 0) {
          this.senderService.uploadFileSmsSenderAlpha(files, data.sisRequestId).subscribe(result => {
            this.successAddEditAlphaForm();
          });
        } else {
          this.successAddEditAlphaForm();
        }
      }
    });
  }

  successAddEditAlphaForm() {
    this.alphaGrid.refresh();
    // REQUIRES_AGCOM_CONFIRM
    this.atlasToast.success('common_success', null);
    this.modalAddEditAlphaModal.close();
    this.addAlphaSenderForm.reset();
    (this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray).clear();
    this.buildFileUpload();
  }

  openModalAddNumeric(): void {
    this.modalAddNumericModal = this.modalService.open(this.modalAddNumeric);
    this.modalAddNumericModal.result.then(
      result => {},
      reason => {
        this.numericGrid.refresh();
      }
    );
  }

  modalAddNumericForm(): void {
    if (!this.addNumericSenderForm.valid) {
      validateFormGroup(this.addNumericSenderForm);
      return;
    }
    this.senderToConfirm = SmsSenderAgcom.deserialize({
      sender: this.addNumericSenderForm.get('number').value
    });
    this.numericGrid.showLoading();
    this.senderService.addAgcomSenderNumeric(this.senderToConfirm).subscribe(data => {
      this.atlasToast.success('common_success', null);
    });
    this.modalAddNumericModal.close();
    this.addNumericSenderForm.reset();
  }

  displayHelpTitle() {
    return environment.brandName === 'aruba';
  }

  onFileUploadChange(event, indexFormArray) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.getFileUpload(indexFormArray)
        .get('file')
        .setValue(file);
    } else {
      this.getFileUpload(indexFormArray)
        .get('file')
        .setValue(null);
    }
    this.addAlphaSenderForm.get('filesUpload').markAsDirty();
    this.buildFileUpload();
  }

  buildFileUpload(length = 2) {
    const filesUpload = this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray;
    if (length === 0) {
      filesUpload.clear();
      return;
    }
    for (let i = 0; i < filesUpload.length; i++) {
      if (!filesUpload.controls[i].get('file').value) {
        filesUpload.removeAt(i);
      }
    }
    if (
      filesUpload.controls[filesUpload.length - 1]?.get('file').value !== null &&
      filesUpload.controls[filesUpload.length - 1]?.get('file').value !== ''
    ) {
      this.addFileUpload();
    }
    while (filesUpload.length < length) {
      this.addFileUpload();
    }
  }

  createFileUpload(): UntypedFormGroup {
    return this.formBuilder.group({
      file: ''
    });
  }

  clearFilesUpload() {
    const filterItems = this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray;
    filterItems.clear();
  }

  addFileUpload(): void {
    const filesUpload = this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray;
    filesUpload.push(this.createFileUpload());
  }

  getFileUpload(index): AbstractControl {
    return (this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray).controls[index];
  }

  removeFileUpload(index): void {
    this.addAlphaSenderForm.markAsDirty();
    (this.addAlphaSenderForm.get('filesUpload') as UntypedFormArray).removeAt(index);
  }

  displayNumericBtn() {
    return false;
  }

  private getDestinationTerritories() {
    this.senderService.getDestinationTerritoriesValidSenders().subscribe((data: any) => {
      this.destinationTerritories = data ? data.filter(territory => territory !== 'AU' && territory.code !== 'AU') : [];
    });
  }

  displayTerritoryName(Iso3166Code: string) {
    const nation = getNationByIso3166Code(Iso3166Code);
    if (nation) {
      return nation[1];
    }
    return '';
  }

  isSubAccountIta() {
    return this.isSubAccount && this.itsIta;
  }

  displayNumericSender() {
    return !this.isSubAccount && this.alertNumericMessage !== this.alertNumericKeyTranslate;
  }
}
